import React from 'react';
import logo from '../../assets/Medicine-Wheel---12-x-12.jpg';
import AdminSidebarMenu from './AdminSidebarMenu';
import './css/sidebar.css';
import useContexts from '../../hooks/useContexts';

const AdminSidebar = ({ url }) => {
    const { isSideBarOpen, setSidebarOpen } = useContexts();
    const handleMenuClick = () => {
        if (window.innerWidth <= 768) {
            setSidebarOpen(false);
        }
    };
    return (
        <div
            className={`Sidebar sidebar_dashboard transition-all duration-300 ease-in-out
    ${isSideBarOpen ? 'mobileSideBarActive block' : 'hidden sm:block'}
  `}
        >
            <div className="row mt-3 logo_img p-0 m-auto flex justify-center items-center">
                <img src={logo} alt="Logo" className="max-w-[120px] h-auto" />
            </div>

            <div className="sidebarMenu">
                <AdminSidebarMenu url={url} handleMenuClick={handleMenuClick} />
            </div>
        </div>

    );
};

export default AdminSidebar;